import { ThemeCustomizerService } from '../app/components/common/theme-customizer/theme-customizer.service';
import { Location, LocationStrategy, NgIf, PathLocationStrategy } from '@angular/common';
import { Router, NavigationCancel, NavigationEnd, RouterOutlet } from '@angular/router';
import { Component } from '@angular/core';
import { filter } from 'rxjs/operators';
import { ThemeCustomizerComponent } from './components/common/theme-customizer/theme-customizer.component';
import { FooterComponent } from './components/common/footer/footer.component';
import { NavbarComponent } from './public/navbar/navbar.component';
import { AuthService } from './admin/auth.service';
import { getLanguages } from 'src/environments/environment';
import { lang } from 'moment';
declare let $: any;

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [ThemeCustomizerComponent, RouterOutlet, NgIf, FooterComponent, NavbarComponent],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent {
    
    title: any;
    location: any;
    isToggled = false;
    routerSubscription: any;
    isLoggedIn
    
    constructor(
        private router: Router,
        public themeService: ThemeCustomizerService, 
        private authService: AuthService
    ) {
        this.initializeLanguage();

        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });

        this.isLoggedIn = this.authService.isLoggedIn()
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit(){
        this.recallJsFuntions();
    }
    private initializeLanguage(): void {
        const langFromUrl = this.getLanguageFromUrl();
        const langFromStorage = localStorage.getItem("language");

        if (langFromStorage != langFromUrl) {
            localStorage.setItem("language", langFromUrl);
        } else if (!langFromStorage) {
            localStorage.setItem("language", getLanguages().EN_US.toString());
        }
    }

    private getLanguageFromUrl(): string | null {
        const urlSegments = window.location.pathname.split('/').filter(segment => segment);
        const langSegment = urlSegments[0];
        console.log("langSegment", langSegment);
        console.log("url", urlSegments);
        if (langSegment === undefined || langSegment === 'en-US') {
            return getLanguages().EN_US.toString();
        }
        return getLanguages().FA_IR.toString();
    }

    recallJsFuntions() {
        this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
        .subscribe(event => {
            this.location = this.router.url;
            if (!(event instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }
    
}